import { render, staticRenderFns } from "./iconButton.vue?vue&type=template&id=7e653a54&scoped=true&"
import script from "./iconButton.vue?vue&type=script&lang=js&"
export * from "./iconButton.vue?vue&type=script&lang=js&"
import style0 from "./iconButton.vue?vue&type=style&index=0&id=7e653a54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e653a54",
  null
  
)

export default component.exports